import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { type TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @category Login */
export type TypeLoginParams = {
  /** 로그인 아이디 */
  username: string;
  /** 비밀번호 */
  password: string;
};

/** @category Login */
export type TypeLoginResponse = {
  code: string;
  message: string;
  data: {
    /** 계정 코드 */
    laborAccountId: number;
    /** 액세스 토큰 */
    accessToken: string;
    /** 리프레시 토큰 */
    refreshToken: string;
    /** 재동의 필요 여부 */
    reConsentRequired: boolean;
    /** 비빌번호 변경 대상 타입 */
    passwordChangeRequiredType: {
      /**
       * @remarks
       * USING_TEMP_PASSWORD: 임시 비밀번호 사용중
       * PASSWORD_OVERDUE_90_DAYS: 비밀번호 변경 기한 초과 90일
       * NONE: 비밀번호 변경 필요 없음
       */
      code: 'USING_TEMP_PASSWORD' | 'PASSWORD_OVERDUE_90_DAYS' | 'NONE';
      /** 비밀번호 변경 모달에 표시될 메세지 */
      text: string;
    };
  };
};

/**
 * @description 로그인 페이지에서 api 요청에 사용되는 커스텀 훅
 */
export const useLogin = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeLoginParams) => {
      const endpoint = '/labor-accounts/login';

      return axiosInstance.post(endpoint, params, { headers: { withoutToken: true } });
    },
  });

  const requestLogin = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeLoginParams;
    onSuccess?: (res: TypeLoginResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestLogin;
};
